import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../providers/api";

const initialState = { notifications: [], isLoading: true };

export const getNotifications = createAsyncThunk(
  "get-notifications",
  async () => {
    const response = await api.notification.getAll();
    return response?.Data;
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  extraReducers: {
    [getNotifications.fulfilled]: (state, action) => {
      state.notifications = action.payload;
      state.isLoading = false;
    },
    [getNotifications.pending]: state => {
      state.isLoading = true;
    },
    [getNotifications.rejected]: state => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    }
  }
});

export default notificationSlice.reducer;
